import { produce } from "immer";

import { statisticsTypes as types } from "../actions";
import { LearnerStatisticsState } from "../../../utils/types/Learner";

const defaultState: {
  learnerStatistics: LearnerStatisticsState;
  loading: boolean;
  loaded: boolean;
} = {
  learnerStatistics: {
    completedCourses: "",
    completedLessons: "",
    completedQuizzes: "",
    totalCourses: "",
    totalLessons: "",
    totalQuizzes: "",
  },
  loading: false,
  loaded: false,
};

const handleSetLearnerStatistics = (
  state: {
    learnerStatistics: LearnerStatisticsState;
    loading: boolean;
    loaded: boolean;
  },
  payload: LearnerStatisticsState
) => {
  state.learnerStatistics = payload;
  state.loading = false;
  state.loaded = true;
  return state;
};

export default produce(
  (
    state: {
      learnerStatistics: LearnerStatisticsState;
      loading: boolean;
      loaded: boolean;
    } = defaultState,
    action
  ) => {
    switch (action.type) {
      case types.SET_LEARNER_STATISTICS_ACTION:
        return handleSetLearnerStatistics(state, action.payload);
      case types.GET_LEARNER_STATISTICS_ACTION:
        return {
          ...state,
          loading: true,
        };
      default:
        return state;
    }
  }
);
